<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import ItemCategoryGroup from "@/router/views/property/settings-template/item-category-group";

export default {
  components: {
    Multiselect,
    ItemCategoryGroup,
  },
  name: "ItemCategory",
  data() {
    return {
      submitted: false,
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "id",
          thStyle: { width: "90px" },
        },
        {
          key: "name",
          sortable: true,
        },
        {
          key: "actions",
          thStyle: { width: "90px" },
        },
      ],
      form: {
        id: 0,
        name: "",
        description: "",
        type: "",
        categoryCode: "",
        itemCategoryGroupId: "",
      },
      indexSelected: -1,
      tableBusy: false,
      categories: [],
      accounts: [],
      selectedRow: {},
      account: [],
      itemCategoryGroupId: 0,
    };
  },
  computed: {
    rows() {
      if (this.filter) {
        return this.totalRows;
      }
      return this.tableData.length;
    },
  },
  validations: {
    form: {
      name: { required },
      description: { required },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addIc() {
      this.onReset();
      this.modalTitle = "Create New Item Category";
      this.$bvModal.show("ic-modal");
    },
    onReset() {
      this.form = {
        id: 0,
        name: "",
        description: "",
        type: "",
        accountId: "",
        categoryCode: "",
        itemCategoryGroupId: this.itemCategoryGroupId,
      };
      this.account = [];
    },
    hideModal() {
      this.$bvModal.hide("ic-modal");
    },

    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let data = cloneDeep(this.form);
        data.accountIds = [];
        let accounts = "";
        this.account.forEach((item) => {
          data.accountIds.push(item.id);
          accounts += item.accountName + ", ";
        });
        if (this.form.id > 0) {
          this.$store
            .dispatch("itemcategory/UpdateItemCategory", data)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.displayType(res.data);
              res.data.accounts = accounts.replace(/,\s*$/, "");
              console.log(res.data);
              this.tableData.splice(this.indexSelected, 1, res.data);
              this.$bvModal.hide("ic-modal");
              this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              console.log(err);
              this.showToast("Something went wrong!", "error");
            });
        } else {
          this.$store
            .dispatch("itemcategory/CreateItemCategory", data)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.displayType(res.data);
              res.data.accounts = accounts.replace(/,\s*$/, "");
              this.tableData.push(res.data);
              this.$bvModal.hide("ic-modal");
              this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
        this.submitted = false;
      }
    },
    updateItem(props) {
      this.form = cloneDeep(props.item);
      this.indexSelected = this.tableData.indexOf(props.item);
      let accounts = [];
      props.item.itemCategoryAccounts.forEach((item) => {
        accounts.push(this.accounts.find((x) => x.id == item.accountId));
      });
      this.account = accounts;
      this.modalTitle = "Update Item Category";
      this.$bvModal.show("ic-modal");
    },
    deleteItem(props) {
      var index = this.tableData.indexOf(props.item);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("itemcategory/DeleteItemCategory", props.item.id)
            .then((res) => {
              if (res.status == 204) {
                this.tableData.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              }
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    displayType(item) {
      if (item.type === "EXP") {
        item.typeName = "Expendable";
      } else if (item.type === "SEP") {
        item.typeName = "Semi-expendable Property";
      } else if (item.type === "PPE") {
        item.typeName = "Property, Plant and Equipment";
      } else {
        item.typeName = "Others";
      }
    },
    getAccount(value) {
      this.form.accountId = value.id;
    },
    getItemCategoryGroup() {
      this.$refs.itemCategoryGroup.getItemCategoryGroup();
    },
    async getAccounts() {
      const account = await this.$store.dispatch("accounts/getAllAccounts");
      account.data.forEach((item) => {
        item.selection = item.accountName + " (" + item.uacs + ")";
      });
      account.data.sort((a, b) => {
        if (a.accountName.trim() < b.accountName.trim()) return -1;
        if (a.accountName.trim() > b.accountName.trim()) return 1;
        return 0;
      });
      this.accounts = account.data;
    },
    async getItemCategory(id) {
      this.tableBusy = true;
      if (id == 0) {
        await this.$store
          .dispatch("itemcategory/GetItemCategory")
          .then((res) => {
            this.tableBusy = false;
            res.data.forEach((item) => {
              let accounts = "";
              item.itemCategoryAccounts.forEach((account) => {
                accounts += account.account.accountName + ", ";
              });
              item.accounts = accounts.replace(/,\s*$/, "");
              this.displayType(item);
            });
            this.tableData = res.data;
          })
          .catch(() => {
            this.tableBusy = false;
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.itemCategoryGroupId = id;
        await this.$store
          .dispatch("itemcategory/GetItemCategoryByGroup", id)
          .then((res) => {
            this.tableBusy = false;
            res.data.forEach((item) => {
              let accounts = "";
              item.itemCategoryAccounts.forEach((account) => {
                accounts += account.account.accountName + ", ";
              });
              item.accounts = accounts.replace(/,\s*$/, "");
              this.displayType(item);
            });
            this.tableData = res.data;
          })
          .catch(() => {
            this.tableBusy = false;
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    handleMouseDown(e, item) {
      this.$refs.itemCategoryGroup.getItemCategoryMoveData(item);
      e.target.style.cursor = "grabbing";
      e.target.parentNode.parentNode.setAttribute("draggable", "true");
    },
    handleMouseUp(e) {
      e.target.style.cursor = "grab";
      e.target.parentNode.parentNode.setAttribute("draggable", "false");
    },
    successTransfer(id) {
      let index = this.tableData.findIndex((x) => x.id == id);
      this.tableData.splice(index, 1);
    },
    callToOpen(event) {
      this.$emit("callToOpen", event);
    },
    saveEmployeeCategories(selected) {
      this.$refs.itemCategoryGroup.saveEmployeeCategories(selected);
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="ic-modal"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="name">Name </label>
          <input
            autocomplete="off"
            id="name"
            type="text"
            v-model="form.name"
            placeholder="Enter Category Name..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.name.$error,
            }"
          />
          <div v-if="submitted && $v.form.name.$error" class="invalid-feedback">
            <span v-if="!$v.form.name.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Description </label>
          <input
            autocomplete="off"
            id="description"
            type="text"
            v-model="form.description"
            placeholder="Enter Description..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.description.$error,
            }"
          />
          <div
            v-if="submitted && $v.form.description.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.description.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="type">Type </label>
          <select name="" id="" class="form-select" v-model="form.type">
            <option value=""></option>
            <option value="EXP">Expendable</option>
            <option value="SEP">Semi-expendable Property</option>
            <option value="PPE">Property, Plant and Equipment</option>
            <option value="OTHERS">Others</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="account">Account</label>
          <multiselect
            v-model="account"
            :options="accounts"
            label="selection"
            @select="getAccount"
            track-by="id"
            value="id"
            deselect-label=""
            select-label=""
            :allow-empty="false"
            :multiple="true"
            :class="{
              'is-invalid': submitted && account.length == 0,
            }"
          />
          <div v-if="submitted && account.length == 0" class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="categoryCode">Category Number </label>
          <input
            autocomplete="off"
            id="categoryCode"
            type="text"
            v-model="form.categoryCode"
            placeholder="Enter Category Number..."
            class="form-control"
          />
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
          <button type="button" class="btn btn-link" @click="hideModal">
            Close
          </button>
        </div>
      </form>
    </b-modal>
    <div class="row">
      <div class="col-md-12">
        <div class="card border">
          <div class="card-body">
            <div class="row">
              <div class="col-md-5">
                <item-category-group
                  ref="itemCategoryGroup"
                  @getItemCat="getItemCategory"
                  @successTransfer="successTransfer"
                  @callToOpen="callToOpen"
                ></item-category-group>
              </div>
              <div class="col-md-7">
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <div class="d-flex align-items-center">
                    <h4 class="card-title my-0 me-1">Item Category List</h4>
                  </div>
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center mb-0">
                      Search:
                      <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2 me-1"
                      ></b-form-input>
                      <b-form-select
                        class="form-select form-select-sm w-auto"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                    </label>
                  </div>
                </div>
                <div class="table-responsive mb-0">
                  <b-table
                    class="datatables"
                    :items="tableData"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :busy="tableBusy"
                    @filtered="onFiltered"
                    bordered
                    outlined
                    hover
                    striped
                    show-empty
                  >
                    <template #empty="scope">
                      <div class="text-center">{{ scope.emptyText }}</div>
                    </template>
                    <template #table-busy>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <div class="preloader-component me-2">
                          <div class="status">
                            <div class="spinner-chase w-20px h-20px">
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                            </div>
                          </div>
                        </div>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                    <template #cell(name)="row">
                      <div>
                        {{ row.value }}
                      </div>
                    </template>
                    <template #cell(actions)="row">
                      <div class="float-end">
                        <i
                          class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                          :id="`category-popover-${row.item.id}`"
                          tabindex="0"
                        ></i>
                        <b-popover
                          :target="`category-popover-${row.item.id}`"
                          triggers="click blur"
                          placement="leftbottom"
                          variant="secondary"
                          custom-class="p-0"
                        >
                          <b-list-group class="w-100 fit">
                            <b-list-group-item
                              button
                              action
                              class="d-flex align-items-center text-info"
                              @click="updateItem(row)"
                              ><i class="mdi mdi-update font-size-18 me-1"></i
                              >Update Item</b-list-group-item
                            >
                          </b-list-group>
                        </b-popover>
                      </div>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>